const BRAND_TYPES = {
    adsBid: 1,
    nativeLab: 2,
    adProFex: 3,
};

export default BRAND_TYPES;
